import { render } from "./dropdown.vue?vue&type=template&id=48129e1f&scoped=true"
import script from "./dropdown.vue?vue&type=script&lang=js"
export * from "./dropdown.vue?vue&type=script&lang=js"

import "./dropdown.vue?vue&type=style&index=0&id=48129e1f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48129e1f"]])

export default __exports__